// extracted by mini-css-extract-plugin
export default {"products_nav":"ProductsNavBar_products_nav__NFxIW"};